import { ComponentProps, ReactElement, VFC } from 'react';
import * as Sentry from '@sentry/nextjs';

import { useTranslation } from 'next-i18next';
import useSWR from 'swr';
import CardRow from '@/components/list/CardRow';
import { API, Structure } from '@/types/app';

const AssetTypeHero: VFC<
  {
    type: keyof typeof Structure.PagedResponseAssetInfoType;
  } & ComponentProps<'div'>
> = ({ type }): ReactElement => {
  const { t } = useTranslation(['detail', 'common']);

  const { data, error } = useSWR<API.Response<Structure.OverallStats>>(
    `/api/data/getOverallMarketStats`,
  );

  if (error) {
    Sentry.captureException(new Error(error));
  }

  const change =
    type === Structure.PagedResponseAssetInfoType.CRYPTO
      ? data?.result.cryptoChangePercent24H
      : data?.result.stockChangePercent24H;

  return (
    <>
      {!error && <div className="hidden pt-6 text-subtitle-1 mobile:block">{t('prev_24h')}</div>}
      <div className="pt-8 pb-3 mobile:pt-6 tablet:pb-3">
        {!error && data ? (
          <h3 className="font-medium text-header-3">
            {t(
              change > 0
                ? `${type === Structure.PagedResponseAssetInfoType.STOCK ? 'stocks' : 'crypto'}_up`
                : `${
                    type === Structure.PagedResponseAssetInfoType.STOCK ? 'stocks' : 'crypto'
                  }_down`,
              {
                percent: change.toFixed(2),
              },
            )}
          </h3>
        ) : (
          <div className="h-6 w-48 animate-pulse rounded-md bg-gray-7" />
        )}
      </div>
      <CardRow type={type} />
    </>
  );
};

export default AssetTypeHero;
